var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 117,
    viewBox: "0 0 94 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.2902 106.642L45.8556 114.13L44.3972 107.807C44.0622 106.342 44.9694 104.884 46.4348 104.542L73.5659 98.2753C75.0313 97.9403 76.4897 98.8475 76.8317 100.313L78.2902 106.642Z",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6291 72.6434C81.9255 61.1163 84.1704 40.1823 72.6434 25.8859C61.1163 11.5895 40.1822 9.34456 25.8858 20.8716C11.5894 32.3987 9.34456 53.3327 20.8716 67.6291C32.3987 81.9255 53.3327 84.1705 67.6291 72.6434Z",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2333 76.1754L31.2223 17.3495L27.3495 10.2108C7.13373 20.8665 -0.61207 45.8901 10.0436 66.1059C20.6993 86.3216 45.7229 94.0674 65.9387 83.4117L62.1496 76.2242",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0572 30.2394C48.2097 24.8865 54.9144 17.6535 53.0325 14.0841C51.1505 10.5147 41.3946 11.9605 31.242 17.3133C21.0894 22.6662 14.3848 29.8992 16.2667 33.4686C18.1487 37.0381 27.9046 35.5922 38.0572 30.2394Z",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4404 79.4063C47.607 80.788 55.2761 79.8459 62.2333 76.1754C69.1905 72.5049 74.3055 66.713 77.2154 60.021C70.0488 58.6393 62.3799 59.5813 55.4226 63.2519C48.4584 66.9224 43.3503 72.7142 40.4404 79.4063Z",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2589 76.1393C70.3795 71.8577 70.0194 55.2178 61.4545 38.973C52.8895 22.7282 39.363 13.0301 31.2424 17.3117C23.1217 21.5933 23.4819 38.2332 32.0468 54.478C40.6118 70.7228 54.1382 80.4209 62.2589 76.1393Z",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3149 62.2679L76.1408 31.2569",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3855 87.0334L59.8187 101.353",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9617 115.462L83.3073 105.547",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeWhite);
export default __webpack_public_path__ + "static/media/globeWhite.d03f87bead2bfb058b9ecf4d222ff0df.svg";
export { ForwardRef as ReactComponent };